module.exports = __webpack_public_path__ + "static/media/SlideArrowLeftBlack.e98008eb.svg";